import {
    IsoDateTimeSchema,
    SubscriptionStatusSchema,
    UuidSchema
} from '@cookspace-shared-contracts/core';
import { z } from 'zod';

/**
 * Локальные Zod-схемы для admin-эндпоинтов /subscriptions/*.
 * Admin-only DTO в shared-contracts не выносятся; форма точно повторяет
 * admin-backend subscriptions.mapper.ts.
 */

export const AdminUserSummarySchema = z.object({
    id: UuidSchema,
    email: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    displayName: z.string().nullable()
});

export type AdminUserSummary = z.infer<typeof AdminUserSummarySchema>;

export const AdminTariffSummarySchema = z.object({
    id: UuidSchema,
    code: z.string(),
    name: z.string(),
    priceRub: z.number(),
    durationDays: z.number().int()
});

export type AdminTariffSummary = z.infer<typeof AdminTariffSummarySchema>;

export const AdminSubscriptionListItemSchema = z.object({
    id: UuidSchema,
    userId: UuidSchema,
    user: AdminUserSummarySchema.nullable(),
    tariffId: UuidSchema,
    tariff: AdminTariffSummarySchema.nullable(),
    status: SubscriptionStatusSchema,
    provider: z.string(),
    providerSubscriptionId: z.string().nullable(),
    providerPaymentMethodId: z.string().nullable(),
    startedAt: IsoDateTimeSchema.nullable(),
    currentPeriodStart: IsoDateTimeSchema.nullable(),
    currentPeriodEnd: IsoDateTimeSchema.nullable(),
    cancelledAt: IsoDateTimeSchema.nullable(),
    cancellationReason: z.string().nullable(),
    cancelAtPeriodEnd: z.boolean(),
    metadata: z.record(z.string(), z.unknown()).nullable(),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema
});

export type AdminSubscriptionListItem = z.infer<typeof AdminSubscriptionListItemSchema>;

export const ListSubscriptionsResponseSchema = z.object({
    items: z.array(AdminSubscriptionListItemSchema),
    total: z.number().int(),
    limit: z.number().int(),
    offset: z.number().int()
});

export type ListSubscriptionsResponse = z.infer<typeof ListSubscriptionsResponseSchema>;

export const GetSubscriptionResponseSchema = z.object({
    subscription: AdminSubscriptionListItemSchema
});

export type GetSubscriptionResponse = z.infer<typeof GetSubscriptionResponseSchema>;

export const CancelSubscriptionRequestSchema = z.object({
    reason: z.string().min(10).max(500),
    immediate: z.boolean().optional()
});

export type CancelSubscriptionRequest = z.infer<typeof CancelSubscriptionRequestSchema>;

export const CancelSubscriptionResponseSchema = z.object({
    subscription: AdminSubscriptionListItemSchema
});

export type CancelSubscriptionResponse = z.infer<typeof CancelSubscriptionResponseSchema>;

export const ExtendSubscriptionRequestSchema = z.object({
    days: z.number().int().min(1).max(365),
    reason: z.string().min(10).max(500)
});

export type ExtendSubscriptionRequest = z.infer<typeof ExtendSubscriptionRequestSchema>;

export const ExtendSubscriptionResponseSchema = z.object({
    subscription: AdminSubscriptionListItemSchema
});

export type ExtendSubscriptionResponse = z.infer<typeof ExtendSubscriptionResponseSchema>;

export const ListSubscriptionsFiltersSchema = z.object({
    status: SubscriptionStatusSchema.optional(),
    search: z.string().optional(),
    userId: UuidSchema.optional(),
    limit: z.number().int().min(1).max(100).optional(),
    offset: z.number().int().min(0).optional()
});

export type ListSubscriptionsFilters = z.infer<typeof ListSubscriptionsFiltersSchema>;

export { IsoDateTimeSchema,SubscriptionStatusSchema };
